"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsenceResponseMessage = void 0;
const model_1 = require("../model");
const utils_1 = require("../utils");
const base_html_1 = require("./base-html");
class AbsenceResponseMessage {
    get replyTo() {
        return this.manager.email;
    }
    get _startString() {
        return (0, utils_1.formatDate)(this.absence.start);
    }
    get _endString() {
        return (0, utils_1.formatDate)((0, utils_1.dateAdd)(this.absence.end, { days: -1 }));
    }
    constructor(vals) {
        Object.assign(this, vals);
    }
    get recipient() {
        return this.employee.email;
    }
    get title() {
        return `${this.absence.type === model_1.TimeEntryType.Vacation ? `Dein Urlaubsantrag` : `Deine Krankmeldung`} wurde ${this._approved ? (this.absence.type.includes("sick") ? "erfasst" : "genehmigt") : "abgelehnt"}.`;
    }
    get _approved() {
        return this.absence.status === model_1.AbsenceStatus.Approved;
    }
    get text() {
        return `
Hallo ${this.employee.firstName},

${this.absence.type === model_1.TimeEntryType.Vacation ? "Dein Urlaubsantrag" : "Deine Krankmeldung"} über den Zeitraum vom ${this._startString} bis ${this._endString} wurde ${!this._approved ? "leider nicht" : ""} akzeptiert!
        ${this.absence.response && this.absence.response.message
            ? `
            Nachricht von ${this.manager.name}: "${this.absence.response.message}"
        `
            : ""}

Liebe Grüße,
Dein Pentacode Team
`;
    }
    get html() {
        return (0, base_html_1.base)(`
            ${(0, base_html_1.paragraph)(`Hallo ${this.employee.firstName},`)}

            ${(0, base_html_1.paragraph)(`${this.absence.type === model_1.TimeEntryType.Vacation ? "Dein Urlaubsantrag" : "Deine Krankmeldung"} über den Zeitraum vom ${this._startString} bis ${this._endString} wurde ${!this._approved ? "leider <strong>nicht" : ""} akzeptiert</strong>!`)}

            ${this.absence.response && this.absence.response.message
            ? (0, base_html_1.paragraph)(`Nachricht von ${this.manager.name}: "${this.absence.response.message}"`)
            : ""}

            ${(0, base_html_1.paragraph)(`
                Liebe Grüße,<br>
                Dein Pentacode Team
            `)}
        `);
    }
}
exports.AbsenceResponseMessage = AbsenceResponseMessage;
//# sourceMappingURL=absence-response.js.map